export enum CollegeSlug {
    ANU = "anu",
    CHRYSM = "chrysm",
    NAU = "nau",
    HHS = "hhs",
    Northstar = "northstar",
    Ogleschool = "ogleschool",
    Demo = "demo",
    COLLECTIV = "collectiv",
    COLLECTIVRIMA = "collectivrima",
    ROBERTFIANCE = "robertfiance",
    PMTSMemphis = "pmtsmemphis",
    Turnagegroup = "turnagegroup",
    Bellus = "bellus",
    Tricoci = "tricoci"
}
